import { render } from "./FavoritesPanelDialog.vue?vue&type=template&id=2dc8087b&scoped=true"
import script from "./FavoritesPanelDialog.vue?vue&type=script&lang=js"
export * from "./FavoritesPanelDialog.vue?vue&type=script&lang=js"

import "./FavoritesPanelDialog.vue?vue&type=style&index=0&id=2dc8087b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc8087b"]])

export default __exports__